import React from 'react';
import { Modal, StaffValidate } from '../../containers';

const StaffModal = () => (
  <Modal empty>
    <StaffValidate />
  </Modal>
);

export default StaffModal;
